import { Avatar as EvergreenAvatar, AvatarProps } from 'evergreen-ui'

const defaultColors = [
  'hsl(46, 100%, 43%)',
  'hsl(336, 39%, 48%)',
  'hsl(12, 68%, 50%)',
  'hsl(202, 100%, 34%)',
  'hsl(356, 95%, 71%)',
  'hsl(32, 84%, 61%)',
  'hsl(278, 100%, 48%)',
  'hsl(175, 100%, 34%)',
]

function stringAsciiCodeSum(value) {
  return [...value].map(letter => letter.charCodeAt(0)).reduce((current, previous) => previous + current)
}

function randomColor(value, colors = defaultColors) {
  if (!value) {
    return 'transparent'
  }
  const sum = stringAsciiCodeSum(value)
  const colorIndex = sum % colors.length
  return colors[colorIndex]
}

export default function Avatar(props: AvatarProps): JSX.Element {
  // gravatars need `?d=404` to fallback with initial vs default gravatar icon
  const src = /secure\.gravatar\.com/.test(props.src || '') ? `${(props.src || '').split('?')[0]}?d=404` : props.src
  const name = props.name || 'Anonymous'
  const initialize = () => name.slice(0, 1).toUpperCase()
  return (
    <EvergreenAvatar
      aria-hidden="true"
      background={`${randomColor(name)} !important`}
      className="avatar"
      getInitials={initialize}
      style={{ color: 'white' }}
      {...props}
      src={src}
    />
  )
}
